import "./App.css";
import Hero from "./Hero";
import { useState } from "react";
import Expense from "./Expense";
import History from "./History";

function App() {
  const [screen, setScreen] = useState("hero");

  return (
    <div className="App">
      {screen === "hero" ? (
        <Hero
          onExpense={() => setScreen("expense")}
          onHistory={() => setScreen("history")}
        />
      ) : screen === "history" ? (
        <History
          onBack={() => setScreen("hero")}
          onEdit={() => setScreen("expense")}
        />
      ) : (
        <Expense onBack={() => setScreen("hero")} />
      )}
    </div>
  );
}

export default App;
